import api from '../../helpers/axios'

export const state = {
    user: null,
    users: []
};

export const getters = {
    user: (state) => state.user,
    users: (state) => state.users
};

export const mutations = {
    setUser(state, newValue) {
        state.user = newValue;
    },
    setUsers(state, newValue) {
        state.users = newValue;
    },
};

export const actions = {
    createUser(_,  data) {
        return new Promise((resolve) => {
            api.post("/users", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateUser(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/users/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteUser(_, id) {
        return new Promise((resolve) => {
            api.delete("/users/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchUser({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/users/"+id).then((res) => {
                commit("setUser", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchUsers({ commit }, {page, limit, search}) {
        let query = "?";
        if (search) {
            query += `username=${search}&`;
        }
        query += `page=${page}&`;
        query += `limit=${limit}&`;
        return new Promise((resolve) => {
            api.get("/users"+query).then((res) => {
                commit("setUsers", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
